import * as React from 'react';

export default function ThumbUp({ className, viewBox }: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      className={className}
      viewBox={viewBox || '0 0 16 16'}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.6001 8.39961C1.6001 7.73687 2.13736 7.19961 2.8001 7.19961C3.46284 7.19961 4.0001 7.73687 4.0001 8.39961V13.1996C4.0001 13.8624 3.46284 14.3996 2.8001 14.3996C2.13736 14.3996 1.6001 13.8624 1.6001 13.1996V8.39961Z"
        fill="currentColor"
      />
      <path
        d="M4.8001 8.26628V12.6108C4.8001 13.2168 5.1425 13.7708 5.68456 14.0418L5.72443 14.0618C6.16877 14.2839 6.65873 14.3996 7.15552 14.3996H11.4884C12.2511 14.3996 12.9078 13.8613 13.0573 13.1134L14.0173 8.3134C14.2154 7.32333 13.4581 6.39961 12.4484 6.39961H9.6001V3.19961C9.6001 2.31595 8.88375 1.59961 8.0001 1.59961C7.55827 1.59961 7.2001 1.95778 7.2001 2.39961V2.93294C7.2001 3.62533 6.97553 4.29903 6.5601 4.85294L5.4401 6.34628C5.02467 6.90018 4.8001 7.57389 4.8001 8.26628Z"
        fill="currentColor"
      />
    </svg>
  );
}
